﻿import React from "react";
import DotLegalDeleteDialogWrapper from "../../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useIncidentDocumentDeleteDialog } from "./IncidentDocumentDeleteDialog.hooks";
import { IncidentDocument } from "../IncidentDocument.types";

export interface IIncidentDocumentDeleteDialogProps {
    onCloseDialog: () => void;
    onDeletedDocument: () => void;
    selectedDocument: IncidentDocument;
    incidentLogId: string;
}

function IncidentDocumentDeleteDialog(props: IIncidentDocumentDeleteDialogProps) {
    const { deleteDocumentClick, inProgress } = useIncidentDocumentDeleteDialog(props);
    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedDocument!.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={() => deleteDocumentClick(props.selectedDocument!.documentId)}
            inProgress={inProgress}
        />
    );
}

export default IncidentDocumentDeleteDialog;
